<template>
  <div>
    <gathering-authorization-list-item
      v-for="gathering in sortedGatherings"
      :key="gathering.Id"
      :gathering="gathering"
      :disableAuthorizationSelects="disableAuthorizationSelects"
      @updatedGathering="updateSourceGatherings"
    />
  </div>
</template>

<script>
import GatheringAuthorizationListItem from '@/components/dashboard/gathering/gathering-authorization-list-item'

export default {
  components: {
    GatheringAuthorizationListItem
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    disableAuthorizationSelects: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    sortedGatherings: function() {
      return this.value.slice(0).sort((x, y) => x.SubmitCode - y.SubmitCode)
    }
  },
  methods: {
    updateSourceGatherings: function() {
      this.$emit('updatedGathering')
    }
  }
}
</script>
